<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="用户姓名">
              <a-input placeholder="请输入用户姓名" v-model="queryParam.nickname"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="患者手机号">
              <a-input placeholder="请输入患者手机号" v-model="queryParam.mobile"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="患者姓名">
              <a-input placeholder="请输入患者姓名" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('patient')">导出</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        <span style="float:right;">
<!--          <a @click="loadData()"><a-icon type="sync" />刷新</a>-->
        </span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="pcaSlot" slot-scope="text">
          <div>{{ getPcaText(text) }}</div>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
<!--            <router-link :to="`/patientInfo/${record.id}`">详情</router-link>-->
<!--            <a-divider type="vertical" />-->
            <a @click="handlePatienData(record)">查看详情</a>
        </span>

      </a-table>
    </div>


    <patient-data-modal ref="patientDataModal"></patient-data-modal>
    <patient-modal ref="modalForm" @ok="modalFormOk"></patient-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import PatientModal from './PatientModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import Area from '@/components/_util/Area'
  import  PatientDataModal from './modules/PatientDataModal'

  export default {
    name: 'PatientList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      PatientModal,
      PatientDataModal
    },
    data () {
      return {
        description: 'patient管理页面',
        // 表头
        columns: [
          {
            title: '患者id',
            align:"center",
            dataIndex: 'id'
          },
          {
            title:'患者姓名',
            align:"center",
            dataIndex: 'patientName'
          },
          {
            title:'患者所属用户',
            align:"center",
            dataIndex: 'toUserName'
          },
          // {
          //   title:'患者头像',
          //   align:"center",
          //   dataIndex: 'headImg',
          //   scopedSlots: {customRender: 'imgSlot'}
          // },
          {
            title:'该患者与用户关系',
            align:"center",
            dataIndex: 'relation',
            customRender:function (res) {
              var relation;
              if(res == 0){
                relation = "本人"
              }else if(res == 1){
                relation = "子女"
              }else if(res == 2){
                relation = "父母"
              }else if(res == 3){
                relation = "夫妻"
              }
              return relation;
            }
          },
          {
            title:'问诊单数量',
            align:"center",
            dataIndex: 'inquiryNum'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/patient/patient/list",
          delete: "/patient/patient/delete",
          deleteBatch: "/patient/patient/deleteBatch",
          exportXlsUrl: "/patient/patient/exportXls",
          importExcelUrl: "patient/patient/importExcel",

        },
        patientId:'',
        dictOptions:{},
        pcaData:''
      }
    },
    created() {
      this.pcaData = new Area()
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      getPcaText(code){
        return this.pcaData.getText(code);
      },
      initDictConfig(){
      },
      handlePatienData(record){
        this.$refs.patientDataModal.showPatien(record);
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>